<ion-header>
    <ion-toolbar>
    <ion-buttons slot="end">
      <ion-button (click)="closeModal()"> 
        <ion-icon slot="icon-only" name="close"></ion-icon>
      </ion-button>
    </ion-buttons>
    <ion-title>{{title}}</ion-title>
  </ion-toolbar>
</ion-header>
<ion-content class="ion-padding">

<div [innerHTML]="description"></div>

</ion-content>

<ion-footer *ngIf="docsUrl">
  <ion-toolbar>
    <ion-buttons slot="end">
      <ion-button [href]="docsUrl" target="_blank" expand="block" color="primary">
        View Documentation <ion-icon name="arrow-redo-outline"></ion-icon>
      </ion-button>
    </ion-buttons>
  </ion-toolbar>
</ion-footer>